import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Dimmer } from "../components/spinner";

import useTable from "../components/useTable";

import axios from "axios";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { SearchInput } from "../ui/inputs/Input";

const CatalogoUnidadFuncional = (props) => {
  let op = require("../modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activo, setActivo] = useState(true);
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const headCells = [
    {
      id: "codigo",
      label: "CÓDIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "actividad",
      label: "NOMBRE",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.coduni.includes(target.value) ||
              x.nomuni.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarClasifTodas = () => {
    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');

    let campos = '*';
    let nomtab = `nomi${codigoNomina}.unidadfuncional`;
    let orden = 'coduni';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };
  const seleccionarLista = (index) => (event) => {
    blanquear();
    props.onHideAcepta(values);
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };
  const handleCloseMensa = () => {
    setMostrar(false);
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };
  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);
    setValues(recordsAfterPagingAndSorting()[index]);
  };
  return (
    <Modal
      {...props}
      size="lg"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarClasifTodas();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2">
        <Modal.Title className="text-light fs-4 fw-bold m-0">
          Seleccionar Unidad Funcional.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <div className="col-6 m-0 mb-2 p-0">
          <SearchInput
            onChange={handleSearch}
          />
        </div>
        <div className="col-12 p-0 m-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.coduni + item.nomuni}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.coduni}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.nomuni}
                    </td>
                    {/* <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "300px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.nombres}
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={activo}
          onClick={seleccionarLista()}
        >
          Aceptar
        </SuccessButton>

        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoUnidadFuncional;
